/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataReturnOrderItem } from './NodataReturnOrderItem';
import {
    NodataReturnOrderItemFromJSON,
    NodataReturnOrderItemFromJSONTyped,
    NodataReturnOrderItemToJSON,
    NodataReturnOrderItemToJSONTyped,
} from './NodataReturnOrderItem';

/**
 * 
 * @export
 * @interface NodataReturnOrderReqVo
 */
export interface NodataReturnOrderReqVo {
    /**
     * 无数据包裹ID
     * @type {number}
     * @memberof NodataReturnOrderReqVo
     */
    id: number;
    /**
     * 历史商品及返送数量；合包提交父商品，数量按套
     * @type {Array<NodataReturnOrderItem>}
     * @memberof NodataReturnOrderReqVo
     */
    items: Array<NodataReturnOrderItem>;
}

/**
 * Check if a given object implements the NodataReturnOrderReqVo interface.
 */
export function instanceOfNodataReturnOrderReqVo(value: object): value is NodataReturnOrderReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function NodataReturnOrderReqVoFromJSON(json: any): NodataReturnOrderReqVo {
    return NodataReturnOrderReqVoFromJSONTyped(json, false);
}

export function NodataReturnOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataReturnOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'items': ((json['items'] as Array<any>).map(NodataReturnOrderItemFromJSON)),
    };
}

export function NodataReturnOrderReqVoToJSON(json: any): NodataReturnOrderReqVo {
    return NodataReturnOrderReqVoToJSONTyped(json, false);
}

export function NodataReturnOrderReqVoToJSONTyped(value?: NodataReturnOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'items': ((value['items'] as Array<any>).map(NodataReturnOrderItemToJSON)),
    };
}

